<template>
  <div class="E3D-video">
    <swiper :banners="banners"></swiper>
    <div class="E3D-content">
      <div class="E3D-video-introduction"> {{ navList.abstract }} </div>
      <breadcrumb :refer="refer"></breadcrumb>

      <!-- E3D 剑法秘籍：一站式进阶学习 -->
      <div class="module-item" v-if="navList.isHaveCourse">
        <div class="module-item-title">
          <img src="@/assets/PC/fenceDetail/praise1.png" alt="">
          <h1>{{ navList.courseTitle }}</h1>
          <img src="@/assets/PC/fenceDetail/praise1.png" alt="">
        </div>

        <!-- <template v-if="isPc"> -->
          <div class="module-item-nav flex2">
            <div class="module-item-nav-item flex2" v-for="item in navList.e3DItems" :key="item.gId" :class="item.gId === params.id ? 'module-item-nav-item-active' : ''" :style="{width: 'calc(100% /' + (navList.e3DItems.length + 0.25) + ')'}">
              <div class="module-item-nav-line" style="width: 25%"></div>
              <div class="module-item-nav-text tc" @click="tabType(item.gId)">
                {{ item.title }} <br v-if="item.subTitle"/> {{ item.subTitle ? item.subTitle : '' }} <br/> {{ item.moduleNum }}门
              </div>
            </div>
            <div class="module-item-nav-line" :style="{width: 'calc(100% /' + (navList.e3DItems.length * 4 + 1) + ')'}"></div>
          </div>

          <div class="module-item-content">
            <loading v-if="loading" />
            <div class="module-item-progress flex0">
              <div v-for="item in navList.e3DItems" :key="item.gId" :style="{width: 'calc(100% /' + (navList.e3DItems.length + 0.25) + ')'}">
                <div class="module-item-progress-item tc" v-if="item.gId === params.id">
                  <div class="progress-box">
                    <div class="module-item-progress-shade flex" :style="{width: Math.floor((item.finish / item.total) * 100) + '%'}">
                      <!-- <img src="@/assets/PC/Fence/progressBar.png"/> -->
                    </div>
                    <div class="progress-num">
                      {{ item.finish }} / {{ item.total }}
                    </div>
                  </div>
                  <div class="module-item-nav-plan-text">您的学习进度</div>
                </div>
              </div>
            </div>

            <div class="module-item-body">
              <div v-if="resData.description" class="module-item-body-item-description">{{ resData.description }}</div>
              <div class="module-item-body-item-List flex4">
                <div class="module-item-body-item-List-item" v-for="itemChild in resData.courses" :key="itemChild.id" @click="goDetail(itemChild.id)">
                  <!-- <div v-if="itemChild.status === 0" class="tc module-item-body-item-List-item-disabled" v-html="titleChange(itemChild.title)">
                  </div>
                  <div v-if="itemChild.status === 1" class="tc module-item-body-item-List-item-living" v-html="titleChange(itemChild.title)">
                  </div>
                  <div v-if="itemChild.status === 2" class="tc module-item-body-item-List-item-success" v-html="titleChange(itemChild.title)">
                  </div> -->
                  <div class="tc" :class="{'module-item-body-item-List-item-disabled': itemChild.status === 0, 'module-item-body-item-List-item-living': itemChild.status === 1, 'module-item-body-item-List-item-success': itemChild.status === 2}" v-html="titleChange(itemChild.title)"></div>
                </div>
              </div>

              <div class="module-item-body-item" v-for="(item, index) in resData.dataList" :key="index">
                <div v-if="item.title && item.courses.length" class="module-item-body-item-title" :class="item.courses.length === 0 ? 'module-item-head-title' : ''">{{ item.title }}</div>
                <div class="module-item-body-item-List flex4">
                  <div class="module-item-body-item-List-item" v-for="itemChild in item.courses" :key="itemChild.id" @click="goDetail(itemChild.id)">
                    <!-- <div v-if="itemChild.status === 0" class="tc module-item-body-item-List-item-disabled" v-html="titleChange(itemChild.title)">
                    </div>
                    <div v-if="itemChild.status === 1" class="tc module-item-body-item-List-item-living" v-html="titleChange(itemChild.title)">
                    </div>
                    <div v-if="itemChild.status === 2" class="tc module-item-body-item-List-item-success" v-html="titleChange(itemChild.title)">
                    </div> -->
                    <div class="tc" :class="{'module-item-body-item-List-item-disabled': itemChild.status === 0, 'module-item-body-item-List-item-living': itemChild.status === 1, 'module-item-body-item-List-item-success': itemChild.status === 2}" v-html="titleChange(itemChild.title)"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <!-- </template> -->

        <!-- <template v-else>
          <div v-for="item in navList.e3DItems" :key="item.gId" class="progress-text">
            <template v-if="item.gId === params.id">
              您的学习进度 {{ item.finish }} / {{ item.total }}
            </template>
          </div>
          <div class="module_list">
            <div class="nav0-item nav0-item1" ref="nav0ItemPop">
              <p class="flex0" @click="IsNones">
                产品与方向 <i class="el-icon-caret-bottom"></i>
              </p>
              <div class="nav0-item-pop products">
                <el-collapse-transition>
                  <ul v-if="isNone">
                    <li v-for="item in navList.e3DItems" :key="item.gId" class="flex0" :class="params.id == item.gId ? 'active3' : ''" @click="tabType(item.gId)">
                      {{ item.title }}
                    </li>
                  </ul>
                </el-collapse-transition>
              </div>
            </div>
          </div>
          <div class="new-module-box">
            <div class="module-item-desc">
              <loading v-if="loading" />
              {{resData.description}}
            </div>
            <div class="module-item-box FenceIndex">
              <div class="FenceIndex-content-right-list" v-if="resData.courses.length">
                <div class="FenceIndex-content-right-list-item" v-for="(item, index) in resData.courses" :key="item.id">
                  <div class="FenceIndex-content-right-list-item-banner cur" @click="goDetail(item.id)">
                    <div v-if="item.isHaveVideo" class="FenceIndex-content-right-list-item-video flex0">
                      <img src="@/assets/PC/fenceDetail/player.png" alt="" width="20%">
                    </div>
                    <img :src="item.imgUrl" alt="" width="100%">
                  </div>
                  <div class="FenceIndex-content-right-list-item-content">
                    <div class="FenceIndex-content-right-list-item-title cur hidden" @click="goDetail(item.id)">
                      {{ item.title }}
                    </div>
                    <div class="flex3">
                      <div class="FenceIndex-content-right-list-item-date">
                        {{ item.releaseTimeStr }}
                      </div>
                      <van-tag v-if="item.isNew" round type="danger" class="FenceIndex-content-right-list-item-IsNew">NEW</van-tag>
                    </div>
                    <p class="FenceIndex-content-right-list-item-introduction cur hidden" @click="goDetail(item.id)">
                      {{ item.introduction }}
                    </p>
                    <div class="FenceIndex-content-right-list-item-tags flex4">
                      <div v-for="(items, index) in item.tags" :key="index" class="tag-item">{{ items }}</div>
                    </div>
                    <div class="FenceIndex-content-right-list-item-operation flex3">
                      <div class="xy-icon">
                        <img src="@/assets/PC/studyF/study_type_k.png" />
                        <span> {{ item.pv }} </span>
                      </div>
                      <div class="xy-icon cur" @click="IsLikes(item.id, item.isPraise, index)" title="点赞">
                        <img v-if="item.isPraise" src="@/assets/PC/studyF/Liked.png" class="animate__animated animate__fadeIn"/>
                        <img v-else src="@/assets/PC/studyF/Like.png" />
                        <span> {{ item.praiseNum }} </span>
                      </div>
                      <div class="xy-icon" @click="Enshrines(item.id, item.isCollect, index)" title="收藏">
                        <van-icon v-if="item.isCollect" name="like" class="xy-icon-Collect animate__animated animate__fadeIn" color="#6b18a8"/>
                        <van-icon v-else name="like-o" class="xy-icon-Collect" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="noData">
                <img src="@/assets/PC/profile/listNone.png" alt="" />
              </div>
            </div>
          </div>
        </template> -->
      </div>

      <!-- 一决高下 -->
      <div class="compete" v-if="navList.isHaveExam">
        <div class="module-item">
          <div class="module-item-title">
            <img src="@/assets/PC/fenceDetail/praise1.png" alt="">
            <h1>{{ navList.examTitle }}</h1>
            <img src="@/assets/PC/fenceDetail/praise1.png" alt="">
          </div>
        </div>
        <div class="final-test-btn flex0 cur" @click="finalTest">
          <span class="mr">学习测试</span>
          <i class="el-icon-right"></i>
        </div>
      </div>

      <!-- 畅享学习礼遇 -->
      <div class="module-item" v-if="navList.isHavePrize">
        <div class="module-item-title">
          <img src="@/assets/PC/fenceDetail/praise1.png" alt="">
          <h1>{{navList.prizeTitle}}</h1>
          <img src="@/assets/PC/fenceDetail/praise1.png" alt="">
        </div>
        <div class="rules">
          <!-- <div class="ruleList-item" v-for="item in ruleList" :key="item.id">
            <div class="ruleList-item-title">
              <i class="el-icon-position"></i>
              <span>{{ item.title }}</span>
            </div>
            <div class="rules-item flex" v-for="itemChild in item.rules" :key="itemChild.id">
              <div class="rules-item-l">
                <div class="rules-item-line"></div>
              </div>
              <div class="rules-item-r">
                <div><b> {{ itemChild.title }} </b></div>
                <p> {{ itemChild.introduction }} </p>
              </div>
            </div>
          </div> -->
          <div class="ruleList-item" v-if="(navList.completeCourseOneGold > 0 && navList.completeCourseAllGold > 0) || (navList.completeSeriesOneGold > 0 && navList.completeSeriesAllGold > 0) || navList.examGold > 0">
            <div class="ruleList-item-title">
              <i class="el-icon-position"></i>
              <span>个人Top奖</span>
            </div>
            <div class="rules-item flex" v-if="navList.completeCourseOneGold > 0 && navList.completeCourseAllGold > 0">
              <div class="rules-item-l">
                <div class="rules-item-line"></div>
              </div>
              <div class="rules-item-r">
                <div><b>学习打卡赢金币</b></div>
                <p>每修炼一门剑术，可换{{navList.completeCourseOneGold}}金币，修炼所有剑术后可获{{navList.completeCourseAllGold}}个金币，金币可换多重好礼；</p>
              </div>
            </div>
            <div class="rules-item flex" v-if="navList.completeSeriesOneGold > 0 && navList.completeSeriesAllGold > 0">
              <div class="rules-item-l">
                <div class="rules-item-line"></div>
              </div>
              <div class="rules-item-r">
                <div><b>进阶学习赢金币</b></div>
                <p>每修炼一个版块剑术，可额外获得{{navList.completeSeriesOneGold}}金币，修炼完所有版块可额外获得{{navList.completeSeriesAllGold}}金币；</p>
              </div>
            </div>
            <div class="rules-item flex" v-if="navList.examGold > 0">
              <div class="rules-item-l">
                <div class="rules-item-line"></div>
              </div>
              <div class="rules-item-r">
                <div><b>考试赢限定勋章</b></div>
                <p>学习测试正确率达到80%及以上，视为取胜，并奖励{{navList.examGold}}个金币以及限定勋章。</p>
              </div>
            </div>
          </div>
          <div class="ruleList-item" v-if="navList.isShowTeamPrize">
            <div class="ruleList-item-title">
              <i class="el-icon-position"></i>
              <span>企业Top奖</span>
            </div>
            <div class="rules-item flex">
              <div class="rules-item-l">
                <div class="rules-item-line"></div>
              </div>
              <div class="rules-item-r">
                <div><b>人才发展奖</b></div>
                <p>员工学习数Top5的企业，获得剑盟社区banner位为期一周的展示特权。</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 登录执行弹窗 -->
      <shadeAlert :shadeConfig="shadeConfig" @closeAlert="closeAlertChange"/>
    </div>
    <!-- <contactUs></contactUs> -->
  </div>
</template>

<script>
import swiper from '@/components/Swiper.vue'
import breadcrumb from '@/components/Breadcrumb/index.vue'
import shadeAlert from "@/components/shadeAlert/index.vue"
import loading from "@/components/loading/index.vue"
import contactUs from "@/components/contactUs/contactUs.vue"

import { BasicData, E3DInfo } from '@/api/E3D.js'
import { GetUserInfo } from '@/api/profile.js'
import { ApiToken } from '@/utils/ApiToken'
import { GetShareData, GetWxShares } from '@/utils/common'
import { mapState } from 'vuex'

export default {
  name: 'E3D-Video',
  data () {
    return {
      loading: false,
      banners: [],
      code: '',
      refer: [
        { name: '首页', href: '/' },
        { name: '习剑', href: '/Home/Fence/FenceIndex' },
        { name: 'E3D 视频'}
      ],
      // !E3D列表分布
      navList: {
        abstract: '',
        e3DItems: []
      },
      // !选中参数
      params: {
        id: 101
      },
      // !
      resData: {
        description: '',
        dataList: [],
        courses: []
      },
      // !规则明细
      ruleList: [
        {
          id: '10001',
          title: '个人Top奖',
          rules: [
            { id: '10010', title: '学习打卡赢金币', introduction: '每修炼一门剑术，可换50金币，修炼所有剑术后可获2250个金币，金币可换多重好礼；' },
            { id: '10011', title: '进阶学习赢金币', introduction: '每修炼一个版块剑术，可额外获得500金币，修炼完所有版块可额外获得2500金币；'},
            { id: '10012', title: '考试赢限定勋章', introduction: '学习测试正确率达到80%及以上，视为取胜，并奖励1000个金币以及限定勋章。'},
          ],
        },
        {
          id: '10002',
          title: '企业Top奖',
          rules: [
            { id: '10013', title: '人才发展奖', introduction: '员工学习数Top5的企业，获得剑盟社区banner位为期一周的展示特权。'}
          ],
        }
      ],
      // !弹窗配置
      shadeConfig: {},
      // !是否有参数
      isCode: false,
      isNone: false,
    }
  },
  created() {
    if(this.$route.query.u) {
      this.$store.commit('e3dinviterId', this.$route.query.u)
    }
  },
  async mounted () {
    this.code = this.$route.params.code || ''
    if(this.code){
      this.isCode = true
    }else{
      this.isCode = false
      this.code = 'E3DVideo'
    }

    const isCdc = (this.$route.params.code || '').toLowerCase() === 'cdc'
    if (isCdc) {
      if (this.token && !this.Infos.name) {
        const res = await GetUserInfo()
        if (res.status === 1) this.$store.dispatch('Profile', res.data)
      }
      if ((!this.token || this.Infos.positionId != ApiToken.e3dPositionId) && this.Infos.partnerType != '10852') {
        this.$router.push('/Home/Index')
        return
      }
    }

    if ((this.code || '').toLowerCase() == 'hmichina') {
      if (this.token && !this.Infos.name) {
        const res = await GetUserInfo()
        if (res.status === 1) this.$store.dispatch('Profile', res.data)
      }
      if ((!this.token || this.Infos.positionId != ApiToken.e3dPositionId) && this.Infos.partnerType != '10852') {
        this.$router.push('/Home/Index')
        return
      }
      if (!this.Infos.isHmiTrial) {
        this.$toast('请先申请成为 HMI 中国版试用者!')
        this.$router.push('/Home/Index')
      }
    }

    this.GetNavList();
    GetShareData(1, this.code, '');
    const share = {
      title: '邀你来战！ AVEVA E3D 剑法秘籍',
      // desc: '一站式进阶“习剑”，享多重惊喜礼遇'
    }
    GetWxShares(share);
  },
  methods: {
    // !获取视频分类
    GetNavList () {
      BasicData({code: this.code}).then(res => {
        if (res.status === 1) {
          this.navList = res.data;
          this.refer[2].name = this.navList.title
          if(this.clientWidth > 768) {
            this.banners = [
              {
                // imgUrl: require('@/assets/PC/Fence/banner1.png'),
                imgUrl: res.data.bannerPC,
                url: '',
                context: ''
              }
            ]
          } else {
            this.banners = [
              {
                // imgUrl: require('@/assets/PC/Fence/banner1-m.png'),
                imgUrl: res.data.bannerMove,
                url: '',
                context: ''
              }
            ]
          }
          if(res.data.e3DItems.length) {
            this.params.id = res.data.e3DItems[0].gId
            this.GetE3DInfo()
          }
        } else if(res.status === -100) {
          this.$toast(res.message)
          this.$router.push('/Home/Index')
        } else {
          this.$toast(res.message)
        }
      })
    },
    // !获取视频分类详情
    GetE3DInfo () {
      this.loading = true
      E3DInfo(this.params).then(res => {
        if(res.status === 1) {
          this.resData = res.data
          this.loading = false
        } else {
          this.$toast(res.message);
          this.loading = false
        };
      });
    },
    // !学习测试系统
    finalTest () {
      if(!this.token) {
        this.shadeConfig = {
          show: true, // 展示隐藏弹窗
          closeIcon: true, // 是否需要关闭按钮
          title: "您还没有登录，<br/>请登录后再来考试吧！",
          text: "", // 弹窗内容
          btnType: "link", // 按钮形式
          btnList: [
            {
              text: '已有剑盟账号，前往登录',
              link: '/Login?redirectUrl=' + this.$route.fullPath,
            },
            {
              text: '没有账号，立即注册',
              link: '/Register?redirectUrl=' + this.$route.fullPath,
            },
          ],
        };
      } else if(this.Infos.isSubmitExam) {
        this.$toast('您已通过学习测试！')
        return false
      } else {
        if(this.isCode) {
          this.$router.push('/Home/GraduationTest?code=' + this.code)
        } else {
          this.$router.push('/Home/GraduationTest')
        }
      }
    },
    // !视频模块切换
    tabType (id) {
      this.isNone = false
      if(this.params.id !== id) {
        this.params.id = id;
        this.GetE3DInfo();
      }
    },
    // !前往视频详情
    goDetail (id) {
        // this.$router.push('/Home/E3DVideoDetail?id=' + id + '&code=' + this.code)
      if(!this.token) {
                        // 取消登录限制
        this.shadeConfig = {
          show: true, // 展示隐藏弹窗
          closeIcon: true, // 是否需要关闭按钮
          title: "您还没有登录，<br/>请登录后再来学习吧！",
          text: "", // 弹窗内容
          btnType: "link", // 按钮形式
          btnList: [
            {
              text: '已有剑盟账号，前往登录',
              link: '/Login?redirectUrl=' + this.$route.fullPath,
            },
            {
              text: '没有账号，立即注册',
              link: '/Register?redirectUrl=' + this.$route.fullPath,
            },
          ],
        };
      } else {
        if(this.isCode) {
          this.$router.push('/Home/E3DVideoDetail?id=' + id + '&code=' + this.code)
        } else {
          this.$router.push('/Home/E3DVideoDetail?id=' + id)
        }
      }
    },
    // !title 换行符 转化
    titleChange (title) {
      const replaceRegex = /(\n\r|\r\n|\r|\n)/g;
      return title.replace(replaceRegex, '<br/>');
    },
    // !关闭登录指引弹窗
    closeAlertChange(state) {
      this.shadeConfig.show = state;
    },
    // !产品展开
    IsNones() {
      this.isNone = !this.isNone;
    },
  },
  components: {
    swiper,
    breadcrumb,
    shadeAlert,
    contactUs,
    loading
  },
  computed: {
    ...mapState(['token', 'clientWidth', 'Infos']),
    isPc: function () {
      return this.clientWidth > 768
    },
  },
}
</script>

<style lang="scss">
  @import './index.scss';
</style>
<style lang="scss" scoped>
  @import '../FenceIndex/index.scss';
  .module_list {
    margin-bottom: vw(30);
    .nav0-item {
      position: relative;
      width: 33%;
      height: vw(60);
      line-height: vw(60);
      border-bottom: 1px #ccc solid;
    }
    .nav0-item-pop {
      background: #f6f6f6;
      position: absolute;
      left: 0;
      top: 30px;
      width: 100%;
      z-index: 9999;
    }
  }
  .progress-text{
    text-align: center;
    font-size: vw(22);
    color: #6B18A8;
  }
  .new-module-box{
    // padding: vw(20);
    // border: 1px #6B18A8 solid;
    // border-radius: vw(10);
  }
  .module-item-desc{
    color: #434343;
    font-size: vw(18);
  }
  .module-item-box{
    margin-top: vw(20);
  }
</style>